import { render, staticRenderFns } from "./create-or-edit-field.vue?vue&type=template&id=653303e0&scoped=true&"
import script from "./create-or-edit-field.vue?vue&type=script&lang=js&"
export * from "./create-or-edit-field.vue?vue&type=script&lang=js&"
import style0 from "./create-or-edit-field.vue?vue&type=style&index=0&id=653303e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653303e0",
  null
  
)

export default component.exports